var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotSmokingAllowed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.563,
  clipPath: "url(#notSmokingAllowed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.008 22.008H8.07v-5.313h15.938a1.33 1.33 0 0 1 1.328 1.328v2.657a1.33 1.33 0 0 1-1.328 1.328M18.695 16.695v5.313M5.414 16.695v5.313M12.055 4.742A3.984 3.984 0 0 1 8.07 8.727a2.656 2.656 0 0 0-2.656 2.656M16.04 4.742a7.97 7.97 0 0 1-7.97 7.969"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notSmokingAllowed_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 15a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 15M5.054 24.944 24.94 5.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notSmokingAllowed_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.75 2.75H26V24H4.75z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "notSmokingAllowed_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})))));
export default SvgNotSmokingAllowed;